export const LOGIC_TEST_DATA_COLLECTION_BASE_URL = '/logic-test-data-collection';

export const logicTestDataCollectionLinks = {
    form: (studyId: string) => `${LOGIC_TEST_DATA_COLLECTION_BASE_URL}/${studyId}`,
    completed: (logicTestId: string) =>
        `${LOGIC_TEST_DATA_COLLECTION_BASE_URL}/${logicTestId}/completed`
};
